module.exports = require('./lib/Markdown.cdn');